<template>
    <div>
        <!--  Country of residence address -->
        <div class="form-section">
            <h2 id="add1" class="form-section__title">
                <span v-for="(item, index) in $root.t('step3.residenceAddress')" :key="index"> {{ item }} <br /> </span>
            </h2>

            <p id="add1-desc" class="form-section__description">
                <span v-for="(item, index) in $root.t('step3.addressDesc')" :key="index"> {{ item }} <br /> </span>
            </p>

            <AddressForm
                :form-data="additionalDetails.countryResidenceAddress"
                :option-countries="$optionData.residenceCountries"
                :city-required="true"
                :zip-code-required="true"
                :address1-required="true"
                :country-readonly="true"
                prefix="AddtionalDetails.ResidenceAddress."
                :aria-label="'add1 add1-desc'"
            />
        </div>

        <!--  Home Country Address -->
        <div class="form-section">
            <h2 id="add2" class="form-section__title">
                <span v-for="(item, index) in $root.t('step3.countryAddress')" :key="index"> {{ item }} <br /> </span>
            </h2>

            <p id="add2-desc" class="form-section__description">
                <span v-for="(item, index) in $root.t('step3.addressDesc')" :key="index"> {{ item }} <br /> </span>
            </p>

            <AddressForm
                :form-data="additionalDetails.homeCountryAddress"
                :option-countries="$optionData.nationalities"
                :country-required="false"
                prefix="AddtionalDetails.CountryAddress."
                :aria-label="'add2 add2-desc'"
            />
        </div>
    </div>
</template>
<script>
import AddressForm from './Form/AddressForm.vue'

export default {
    name: 'Addresses',
    components: {
        AddressForm,
    },
    data() {
        return {
            additionalDetails: this.$formData.policyHolder.additionalDetails,

            residenceCountryData: {
                title: 'Country Of Residence Address',
                description: 'If you have an address in this Country, please add it here:',
            },
            homeCountryData: {
                title: 'Home Country Address (Country Of Your Primary Passport)',
                description: 'If you have an address in this Country, please add it here:',
            },
        }
    },
    mounted() {},
}
</script>
